import StarRateIcon from '@mui/icons-material/StarRate'

export default function StylistRow({ stylist }) {
  const t = useI18n()

  // const renderBadge = () => {
  //   if (!stylist.isGuarantee) return
  //   return <span className='ml-1'><C.Image src={ cdn('images/badge/guarantee64.png') } className='w-5 h-5' alt=''/></span>
  // }

  const renderPrice = () => {
    if (!stylist.stylistService) return
    const { name, minPrice, maxPrice } = stylist.stylistService
    let range = getPriceRangeText(minPrice, maxPrice, t)
    if (range.includes('~')) range = `${ minPrice.currency() } ${ t('common:up') }`

    return (
      <div className='py-1 px-2 tracking-wider text-white bg-gray-100 text-gray-500 rounded-[4px]'>
        { name } { range }
      </div>
    )
  }

  return (
    <div className='hover:bg-gray-100'>
      <div className='container flex pb-4 flex-wrap'>
        <C.Link href={ h.path.stylist({ id: stylist.user.id }) } noUnderline className='flex flex-wrap flex-1'>
          <div className='shrink-0 pt-5 md:mt-1'>
            <C.Image
              src={ stylist.user.avatar }
              className='w-16 h-16 mr-1 md:mr-2 md:w-24 md:h-24 lg:w-28 lg:h-28 rounded-full'
            />
          </div>
          <div className='flex-1 space-y-[0.15rem] pt-5 px-2 md:space-y-1 lg:space-y-2'>
            <div className='font-medium md:mt-2 lg:mt-4 flex items-center'>
              <span>{ stylist.user.name }</span>
              {/* { renderBadge() } */}
            </div>

            <div className='tracking-wider text-sm text-gray-700 line-clamp-1 pb-1'>
              { stylist.studio.address }
            </div>

            <div className='flex md:flex-wrap text-xs'>
              <div className='shrink-0 flex items-center text-xs text-gray-700 space-x-1 mr-2 md:w-full md:mb-3'>
                <span className='text-yellow-400 -translate-y-0.5 text-sm'>
                  <StarRateIcon fontSize='inherit' />
                </span>
                <span className='text-xs'>
                  { stylist.rating.toFixed(1) } ({ t('page:userId.ratingCount', { count: stylist.totalRatingCount.format() }) })
                </span>
                {/* <C.Stars score={ stylist.rating } className='w-4 h-4'/>
                <div>{ t('page:stylists.ratingCount', { count: stylist.totalRatingCount.format() }) }</div> */}
              </div>

              { renderPrice() }

            </div>
          </div>
        </C.Link>
        <div className='w-full md:w-1/2 shrink-0 py-4 flex'>
          { stylist.customCovers.map(cover => (
            <C.Link href={ h.path.post({ id: cover.postId }) } preventDefault
              key={ cover.postId } className='w-1/3 px-1 lg:px-2'>
              <div onClick={ () => h.openPost({ id: cover.postId }) }>
                <C.Image
                  src={ cover.coverUrl }
                  className='pt-[133%] rounded-[5px] shadow'
                />
              </div>
            </C.Link>
          )) }
        </div>

      </div>
    </div>
  )

}
